<v-public-bottom-gradient-wrapper>

  @if (aal === 'aal1') {
    <div class="flex flex-col gap-10 w-[90vw] md:min-w-sm md:w-xl relative max-w-[480px]">
      <v-public-logo-header [header]="'pages.login.header' | transloco" [subheader]="'pages.login.subheader' | transloco"></v-public-logo-header>

      <v-card padding="lg" variant="glass-v2">
        <div class="vops-kratos-login-form" slot="body">
          @if (initialFlowLoading) {
            <div class="vops-kratos-login-loading">
              <p-skeleton height="100%"></p-skeleton>
              <p-skeleton height="100%"></p-skeleton>
              <p-skeleton height="100%"></p-skeleton>
            </div>
          }
          @if (!initialFlowLoading && loginFlow) {
            <app-kratos-form-v2
              #kf
              [flow]="loginFlow"
              [busy]="isCompletingLoginFlow()"
              (submitFlow)="submitFlow($event)"
              [renderFallback]="false">
              @if (kf.hasMessages()) {
                <ng-template vKfName="messages"></ng-template>
              }

              <div class="flex flex-col gap-4">
                @if (kf.isVisible('default-input-identifier')) {
                  <div class="col-span-1">
                    <ng-template [vKfName]="'default-input-identifier'">
                    </ng-template>
                  </div>
                }
                <div class="col-span-1">
                  <ng-template #forgotPassword>
                    <a
                      tabindex="0"
                      class="text-sm text-surface-1-v2-contrast-subtle block no-underline hover:text-primary"
                      [routerLink]="['/recovery']">
                      {{ 'pages.login.forgotPassword' | transloco }}
                    </a>
                  </ng-template>
                  <ng-template
                    [vKfName]="'password-input-password'"
                    [vKfFormFieldHeader]="forgotPassword"></ng-template>
                </div>
                <div class="col-span-1 mt-2">
                  <ng-template
                    [vKfName]="'password-input-method-password'"></ng-template>
                </div>

                @if (kf.hasOidcProviders()) {
                  <div class="flex items-center gap-4 my-4">
                    <div class="h-px bg-surface-3 flex-1"></div>
                    <span class="text-subtle text-sm">{{ 'pages.login.separator' | transloco }}</span>
                    <div class="h-px bg-surface-3 flex-1"></div>
                  </div>

                  <!-- two columns; an odd last provider spans the full row -->
                  <div class="grid grid-cols-2 gap-4 *:last:odd:col-span-2">
                    @if (kf.isVisible('oidc-input-provider-google')) {
                      <div>
                        <ng-template
                          [vKfName]="'oidc-input-provider-google'"></ng-template>
                      </div>
                    }
                    @if (kf.isVisible('oidc-input-provider-microsoft')) {
                      <div>
                        <ng-template
                          [vKfName]="
                            'oidc-input-provider-microsoft'
                          "></ng-template>
                      </div>
                    }
                    @if (kf.isVisible('oidc-input-provider-github')) {
                      <div>
                        <ng-template
                          [vKfName]="'oidc-input-provider-github'"></ng-template>
                      </div>
                    }
                    @if (kf.isVisible('oidc-input-provider-apple')) {
                      <div>
                        <ng-template
                          [vKfName]="'oidc-input-provider-apple'"></ng-template>
                      </div>
                    }
                  </div>
                }
              </div>
            </app-kratos-form-v2>
          }
        </div>
      </v-card>
      <div class="text-center text-subtle">
        {{ 'pages.login.signupHint' | transloco }}
        <a routerLink="/register" class="text-primary font-bold">{{ 'pages.login.createAccount' | transloco }}</a>
      </div>
    </div>
  }

  @if (aal === 'aal2') {
    <div class="flex flex-col gap-10 min-w-sm w-xl">
      <v-public-logo-header [header]="'pages.login.twoFAHeader' | transloco" ></v-public-logo-header>

      <v-card padding="lg" variant="glass-v2" [fullWidth]="true">
        <div slot="body">
          @if (twoFAFlow) {
            <app-kratos-form-v2
              #twoFa
              [flow]="twoFAFlow"
              (submitFlow)="submitTwoFAFlow($event)"
              [renderFallback]="false">
              <div class="flex flex-col gap-4">

                @if(twoFa.hasMessages()) {
                  <ng-template vKfName="messages"></ng-template>
                }

                @if(twoFa.isVisible('webauthn-input-webauthn-login-trigger-')) {
                  <div class="col-span-1">
                    <ng-template
                      [vKfName]="
                        'webauthn-input-webauthn-login-trigger-'
                      "></ng-template>
                  </div>
                }
                @if(twoFa.isVisible('totp-input-totp-code')) {
                  <div class="col-span-1">
                    <ng-template
                      [vKfName]="
                        'totp-input-totp-code'
                      "></ng-template>
                  </div>
                }
                @if(twoFa.isVisible('totp-input-method-totp')) {
                  <div class="col-span-1">
                    <ng-template
                      [vKfName]="
                        'totp-input-method-totp'
                      "></ng-template>
                  </div>
                }
                </div>
            </app-kratos-form-v2>
          }
        </div>
      </v-card>
    </div>
  }
</v-public-bottom-gradient-wrapper>
